import { createContext } from "react";
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BadgeGroupItemContext = createContext({
    isHidden: false,
});
